document.addEventListener('DOMContentLoaded', () => {
    const toggleCheckbox = document.getElementById('toggleCheckbox');
    const switchSlider = document.querySelector('.switch-slider');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    toggleCheckbox.checked = true;
                    switchSlider.classList.add('active');
                }, 1500);
            }
        });
    });

    observer.observe(document.getElementById('switch'));

    toggleCheckbox.addEventListener('change', () => {
        if (toggleCheckbox.checked) {
            switchSlider.classList.add('active');
        } else {
            switchSlider.classList.remove('active');
        }
    });
});